import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useTestId from '@ori/testid-generator';
import * as AddToBasketEvent from '@ori-events/add-to-basket';
import { Check, EmptyBasket, MiniBag, MiniBagFilled, OriflameSpinner, ShoppingBasketFilled } from '@ori-ui/icons';
import { useCallback, useState } from 'react';
import { Markets } from "./helpers";
import { useOnClickEvent, useQuickBuyEvents } from "./hooks";
import { Root } from "./styles";
import { QUICK_BUY_BUTTON_STATE_DEFAULT, QUICK_BUY_BUTTON_STATE_LOADING, QUICK_BUY_BUTTON_STATE_SUCCESS, QUICK_BUY_FILLED_CN_ICON, QUICK_BUY_FILLED_ICON, QUICK_BUY_LOADING_ICON, QUICK_BUY_OUTLINED_CN_ICON, QUICK_BUY_OUTLINED_ICON, QUICK_BUY_SUCCESS_ICON } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var renderIcon = function renderIcon(state, tenant) {
  switch (state) {
    case QUICK_BUY_BUTTON_STATE_LOADING:
      return /*#__PURE__*/_jsx(OriflameSpinner, {
        "data-testid": QUICK_BUY_LOADING_ICON
      });
    case QUICK_BUY_BUTTON_STATE_SUCCESS:
      return /*#__PURE__*/_jsx(Check, {
        "data-testid": QUICK_BUY_SUCCESS_ICON
      });
    default:
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "outlinedIcon",
          children: tenant === Markets.CN ? /*#__PURE__*/_jsx(EmptyBasket, {
            "data-testid": QUICK_BUY_OUTLINED_CN_ICON
          }) : /*#__PURE__*/_jsx(MiniBag, {
            "data-testid": QUICK_BUY_OUTLINED_ICON
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "filledIcon",
          children: tenant === Markets.CN ? /*#__PURE__*/_jsx(ShoppingBasketFilled, {
            "data-testid": QUICK_BUY_FILLED_CN_ICON
          }) : /*#__PURE__*/_jsx(MiniBagFilled, {
            "data-testid": QUICK_BUY_FILLED_ICON
          })
        })]
      });
  }
};
export var QuickBuyButton = function QuickBuyButton(_ref) {
  var addToBasketMethod = _ref.addToBasketMethod,
    ariaLabel = _ref.ariaLabel,
    currentPrice = _ref.currentPrice,
    currentProductCode = _ref.currentProductCode,
    lineNumber = _ref.lineNumber,
    name = _ref.name,
    originalItemCode = _ref.originalItemCode,
    placement = _ref.placement,
    position = _ref.position,
    smallerOnMobile = _ref.smallerOnMobile,
    _ref$tenant = _ref.tenant,
    tenant = _ref$tenant === void 0 ? '' : _ref$tenant,
    onQuickBuyButtonClick = _ref.onQuickBuyButtonClick;
  var _useState = useState(QUICK_BUY_BUTTON_STATE_DEFAULT),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  useQuickBuyEvents({
    currentProductCode: currentProductCode,
    setState: setState
  });
  var onClickEvent = useOnClickEvent({
    addToBasketMethod: addToBasketMethod,
    currentPrice: currentPrice,
    currentProductCode: currentProductCode,
    lineNumber: lineNumber,
    name: name,
    originalItemCode: originalItemCode,
    placement: placement,
    position: position,
    onQuickBuyButtonClick: onQuickBuyButtonClick
  });
  var dispatchOnClickEvent = useCallback(function () {
    if (onClickEvent instanceof CustomEvent) {
      if (onClickEvent.type === AddToBasketEvent.Name) {
        setState(QUICK_BUY_BUTTON_STATE_LOADING);
      }
      window.dispatchEvent(onClickEvent);
    }
  }, [onClickEvent]);
  var onClick = useCallback(function (event) {
    event.preventDefault();
    event.stopPropagation();
    if (onClickEvent instanceof CustomEvent && state === QUICK_BUY_BUTTON_STATE_DEFAULT) {
      if (onQuickBuyButtonClick) {
        onQuickBuyButtonClick({
          event: onClickEvent,
          initialState: state,
          setState: setState
        });
      } else {
        dispatchOnClickEvent();
      }
    }
  }, [dispatchOnClickEvent, onClickEvent, onQuickBuyButtonClick, state]);
  return /*#__PURE__*/_jsx(Root, {
    ariaLabel: ariaLabel,
    smallerOnMobile: smallerOnMobile,
    state: state,
    tenant: tenant,
    testId: "".concat(getTestId('quick-buy'), "-").concat(currentProductCode),
    onClick: onClick,
    children: renderIcon(state, tenant)
  });
};
//# sourceMappingURL=QuickBuyButton.js.map